import { Banner, Button, Spinner, TextField } from "@shopify/polaris"
import React, { useState } from "react"
import { useGQL } from "../hooks/useGQL"
import { useTranslation } from "react-i18next"

const CollectionCreator = (props) => {
	const [title, setTitle] = useState("")
	const [loading, setLoading] = useState(false)
	const [errors, setErrors] = useState([])
	const gqlQuery = useGQL()
	const { t } = useTranslation()

	const discard = () => {
		setTitle("")
		setErrors([])
		props.discard()
	}

	const create = async () => {
		setLoading(true)

		const res = await gqlQuery(
			`
			mutation collectionCreate($input: CollectionInput!) {
				collectionCreate(input: $input) {
					collection {
						id
						title
					}
					userErrors {
						field
						message
					}
				}
			}
		`,
			{ input: { title: title } },
		)

		setLoading(false)
		if (res?.data?.collectionCreate?.collection) {
			setTitle("")
			setErrors([])
			props.onCollectionCreated(res.data.collectionCreate.collection)
		} else if (res?.data?.collectionCreate?.userErrors?.length > 0) {
			setErrors(
				res.data.collectionCreate.userErrors.map((e) => e.message),
			)
		} else if (res?.errors?.length > 0) {
			setErrors(res.errors.map((e) => e.message))
		} else {
			setErrors([t("error.unexpected_error_creating_collection")])
		}
	}

	return (
		<div>
			{loading ? (
				<div style={{ display: "flex" }}>
					<Spinner size="small" />
					<p style={{ marginLeft: "1rem" }}>
						{t("components.collection_creator.creating_collection")}
					</p>
				</div>
			) : (
				<TextField
					name={t("components.collection_creator.collection_title")}
					type="text"
					value={title}
					placeholder={t(
						"components.collection_creator.collection_title",
					)}
					onChange={(e) => setTitle(e)}
				/>
			)}
			{errors.length > 0 && (
				<div style={{ marginTop: "1rem" }}>
					<Banner
						title={t("error.error_creating_collection")}
						status="critical"
					>
						<p>Errors:</p>
						{errors.map((e, i) => {
							return (
								<p key={`createCollection-error-${i + 1}`}>
									{i}. {e}
								</p>
							)
						})}
					</Banner>
				</div>
			)}
			<div
				style={{
					marginTop: "0.5rem",
					display: "flex",
					width: "100%",
					justifyContent: "flex-end",
					gap: "0.5rem",
				}}
			>
				<Button size="slim" disabled={loading} onClick={discard}>
					{t("common.cancel")}
				</Button>
				<Button size="slim" primary disabled={loading} onClick={create}>
					{t("common.create")}
				</Button>
			</div>
		</div>
	)
}

export default CollectionCreator
